import { useCreateGroup } from '@vlabs/api/artemy/client';
import type {
  CreateGroupRequest,
} from '@vlabs/api/artemy/model';
import { toast } from 'react-toastify';

import { useCreateSourceGroupTranslation } from '../i18n';
import type {
  CreateSourceGroupFormValues,
  CreateSourceGroupProps,
} from '../types';

interface UseCreateSourceGroupProps extends CreateSourceGroupProps {
  onSuccess?: VoidFunction;
}

export function useCreateSourceGroup({
  onCreateSourceGroup = undefined,
  onSuccess = undefined,
}: UseCreateSourceGroupProps = {}): {
    onSubmit: (data: CreateSourceGroupFormValues) => Promise<void>;
    isPending: boolean;
  } {
  const { t } = useCreateSourceGroupTranslation();
  const createGroup = useCreateGroup();

  async function onSubmit(data: CreateSourceGroupFormValues): Promise<void> {
    const request: CreateGroupRequest = {
      group_name: data.group_name,
      description: data.description || undefined,
      owner_department: data.owner_department,
      permission_tag: data.permission_tag,
    };

    try {
      const { group_id: groupId } = await createGroup.mutateAsync({ data: request });

      onSuccess?.();
      toast.success(t('on_success'));
      onCreateSourceGroup?.(groupId);
    } catch {
      toast.error(t('on_error'));
    }
  }

  return {
    onSubmit,
    isPending: createGroup.isPending,
  };
}
